/**
 * Team management page
 * 
 * Per design.md: Use @uprosal/ui components, semantic tokens, lucide icons
 */

import { motion } from 'framer-motion';
import {
    Card, CardContent, CardHeader, CardTitle,
    Badge,
    Users, Shield,
} from '@uprosal/ui';

export function TeamPage() {
    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-foreground">Team</h1>
                    <p className="text-muted-foreground mt-1">
                        Manage team members and permissions
                    </p>
                </div>
                <Badge variant="outline" className="text-muted-foreground">
                    Team Invites Coming Soon
                </Badge>
            </div>

            {/* Team members list */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
            >
                <Card>
                    <CardHeader>
                        <CardTitle className="text-lg">Team Members</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        {/* Owner */}
                        <div className="flex items-center justify-between p-4 rounded-lg bg-muted">
                            <div className="flex items-center gap-4">
                                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                                    <span className="text-sm font-medium text-primary-foreground">JD</span>
                                </div>
                                <div>
                                    <p className="font-medium text-foreground">John Doe</p>
                                    <p className="text-sm text-muted-foreground">john@example.com</p>
                                </div>
                            </div>
                            <Badge variant="success" className="flex items-center gap-1">
                                <Shield className="w-3 h-3" />
                                Owner
                            </Badge>
                        </div>

                        {/* Empty state */}
                        <div className="text-center py-8">
                            <Users className="w-12 h-12 mx-auto mb-3 text-muted-foreground opacity-50" />
                            <p className="text-muted-foreground mb-4">
                                Team invites coming soon. Stay tuned for collaborative features.
                            </p>
                        </div>
                    </CardContent>
                </Card>
            </motion.div>

            {/* Permissions info */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.1 }}
            >
                <Card>
                    <CardHeader>
                        <CardTitle className="text-lg">Role Permissions</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-3 text-sm">
                        <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
                            <span className="font-medium text-foreground">Owner</span>
                            <span className="text-muted-foreground">Full access, billing, team management</span>
                        </div>
                        <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
                            <span className="font-medium text-foreground">Admin</span>
                            <span className="text-muted-foreground">Manage prompts, view analytics</span>
                        </div>
                        <div className="flex items-center justify-between p-3 rounded-lg bg-muted">
                            <span className="font-medium text-foreground">Member</span>
                            <span className="text-muted-foreground">Use prompts, generate proposals</span>
                        </div>
                    </CardContent>
                </Card>
            </motion.div>
        </div>
    );
}
